// src/user/pages/Subscriptions.js
import React from "react";

const Subscriptions = () => {
  return (
    <div style={{ maxWidth: 900, margin: "20px auto" }}>
      <h2>Subscriptions</h2>

      <p style={{ color: "#666", marginTop: 10 }}>
        This page will show channels you are subscribed to.
      </p>

      <div
        style={{
          marginTop: 20,
          padding: 20,
          background: "#fff",
          borderRadius: 8,
          textAlign: "center",
        }}
      >
        <p>No subscriptions found.</p>
      </div>
    </div>
  );
};

export default Subscriptions;
